// extracted by mini-css-extract-plugin
module.exports = {"year":"styles_year__2tzBi","yearTitle":"styles_yearTitle__3JWUQ","yearIcon":"styles_yearIcon__1mb5X"};